import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
  groups: { count: 0, rows: [] },
  groupsFilter: {},
  group: {},
  loading: false,
  checkDelete: {}
};

const setGroupsFilter = (state, action) => {
  return updateObject(state, {
    groupsFilter: action.groupsFilter,
  });
};

const requestGroupsStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchGroupsSuccess = (state, action) => {
  return updateObject(state, {
    groups: action.groups,
    loading: false
  });
};

const fetchGroupByIdSuccess = (state, action) => {
  return updateObject(state, {
    group: action.group,
    loading: false
  });
}

const requestGroupsFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const deleteGroupsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const checkDeleteGroupsSuccess = (state, action) => {
  return updateObject(state, { 
    checkDelete: action.checkDelete,
    loading: false
  });
}

const updateGroupsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const postGroupsSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_GROUPS_START: return requestGroupsStart(state, action);
    case actionTypes.FETCH_GROUPS_SUCCESS: return fetchGroupsSuccess(state, action);
    case actionTypes.FETCH_GROUPS_BY_ID_SUCCESS: return fetchGroupByIdSuccess(state, action);
    case actionTypes.REQUEST_GROUPS_FAIL: return requestGroupsFail(state, action);
    case actionTypes.DELETE_GROUPS_SUCCESS: return deleteGroupsSuccess(state, action);
    case actionTypes.CHECK_DELETE_GROUPS_SUCCESS: return checkDeleteGroupsSuccess(state, action);
    case actionTypes.UPDATE_GROUPS_SUCCESS: return updateGroupsSuccess(state, action);
    case actionTypes.POST_GROUPS_SUCCESS: return postGroupsSuccess(state, action);
    case actionTypes.SET_GROUPS_FILTER: return setGroupsFilter(state, action);

    default: return state;
  }
};

export default reducer;
